import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import InputControl from '../../Components/Common/TextField/TextField';
import DropDown from '../../Components/Common/DropDown/DropDown';
import Button from '../../Components/Button/Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {V_GetAdminGroupsByUPN, V_GetAllFormLabels, V_SaveEmailTemplate } from '../../Reducers/dcoi';
import { ArrowBackIos } from '@mui/icons-material';
import Spinner from '../../Components/Common/Spinner/Spinner';
import QuillEditor from '../../Components/Common/QuillEditor/QuillEditor';
import Toster from '../../Components/Common/Toster/Toster';
import "./VcoiManageAdminPermission";

function ManageEmailTemplate() {
  const { V_policiesListByUPN, V_languageList, inProgress } = useSelector((state) => state.dcoi);
  const location = useLocation();
  const emailData = location.state?.emailData || null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [severity, setSavirity] = useState();
  const [alert, setAlert] = useState();
  const [message, setMessage] = useState();
  const [emailTempName, setEmailTempName] = useState(emailData?.Title || "");
  const [adminGroup, setAdminGroup] = useState(emailData?.AdminGroupId || "");
  const [language, setLanguage] = useState(emailData?.FormLabelId || "");
  const [selectedType, setSelectedType] = useState('INVITATION');
  const [invitationEmailSubject, setinvitationEmailSubject] = useState(emailData?.SubjectInvitation || '');
  const [reminderEmailSubject, setReminderEmailSubject] = useState(emailData?.SubjectReminder || '');
  const [autoReminderEmailSubject, setAutoReminderEmailSubject] = useState(emailData?.SubjectAutoReminder || '')
  const [invitationEmailContent, setInvitationEmailContent] = useState(emailData?.BodyInvitation || '');
  const [reminderEmailContent, setReminderEmailContent] = useState(emailData?.BodyReminder || '');
  const [autoReminderEmailContent, setAutoReminderEmailContent] = useState(emailData?.BodyAutoReminder || '');
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    dispatch(V_GetAdminGroupsByUPN());
    // dispatch(GetAdminGroups());
    dispatch(V_GetAllFormLabels());
  }, []);

  useEffect(() => {
    if (emailData) {
      setEmailTempName(emailData?.Title || '');
      setAdminGroup(emailData?.AdminGroupId || '');
      setLanguage(emailData?.FormLabelId || '');
      setinvitationEmailSubject(emailData?.SubjectInvitation || '');
      setInvitationEmailContent(emailData?.BodyInvitation || '');
      setReminderEmailSubject(emailData?.SubjectReminder || '');
      setReminderEmailContent(emailData?.BodyReminder || '');
      setAutoReminderEmailSubject(emailData?.SubjectAutoReminder || '');
      setAutoReminderEmailContent(emailData?.BodyAutoReminder || '');
    }
  }, []); // Run only once on mount


  useEffect(() => {
    const isEmpty = (value) => !value || value.trim() === "" || value.trim() === "<p><br></p>";

    const isFormValid =
      emailTempName.trim() !== "" &&
      adminGroup !== "" &&
      language !== "" &&
      !isEmpty(invitationEmailSubject) &&
      !isEmpty(invitationEmailContent) &&
      !isEmpty(reminderEmailSubject) &&
      !isEmpty(reminderEmailContent) &&
      !isEmpty(autoReminderEmailSubject) &&
      !isEmpty(autoReminderEmailContent);

    setIsDisabled(!isFormValid);
  }, [
    emailTempName, adminGroup, language,
    invitationEmailSubject, invitationEmailContent,
    reminderEmailSubject, reminderEmailContent,
    autoReminderEmailSubject, autoReminderEmailContent,
    selectedType // Ensure re-validation when switching tabs
  ]);





  const validate = () => {
    let tempErrors = {};
    if (!emailTempName.trim()) tempErrors.emailTempName = "Email template name is required.";
    if (!adminGroup) tempErrors.adminGroup = "Entity Admin Group is required.";
    if (!language) tempErrors.language = "Language is required.";
    if (!invitationEmailSubject.trim()) tempErrors.invitationEmailSubject = "Email subject is required.";
    if (!invitationEmailContent.trim()) tempErrors.invitationEmailContent = "Email content is required.";
    if (!reminderEmailSubject.trim()) tempErrors.reminderEmailSubject = "Email subject is required.";
    if (!reminderEmailContent.trim()) tempErrors.reminderEmailContent = "Email content is required.";
    if (!autoReminderEmailSubject.trim()) tempErrors.autoReminderEmailSubject = "Email subject is required.";
    if (!autoReminderEmailContent.trim()) tempErrors.autoReminderEmailContent = "Email content is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleClick = (type) => setSelectedType(type);

  const handleSave = () => {
    if (!validate()) return;
    const newTemplateData = {
      Id: emailData?.ID,
      Title: emailTempName,
      AdminGroupId: adminGroup,
      FormLabelId: language,
      SubjectInvitation: invitationEmailSubject,
      BodyInvitation: invitationEmailContent,
      SubjectReminder: reminderEmailSubject,
      BodyReminder: reminderEmailContent,
      SubjectAutoReminder: autoReminderEmailSubject,
      BodyAutoReminder: autoReminderEmailContent
    };

    try {
      dispatch(V_SaveEmailTemplate(newTemplateData)).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setTimeout(()=>{
            navigate(`/app-vcoi/vcoisitecontent/VcoiManageEmailTemplateHome`);
          },1000)
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setSavirity("error");
          setMessage(res?.payload?.data[0]?.error)
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSavirity("error");
        }
      });
    } catch (error) {
      setAlert(true);
      setSavirity("error");
      setMessage(error)
    }

  };

  return (
    <>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
          {emailData ? 'Edit Email Template' : 'Add Email Template'}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{ color: " #212129", display: 'flex', alignItems: "center", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
            onClick={() => navigate(`/app-vcoi/vcoisitecontent/VcoiManageEmailTemplateHome`)}
          >
            <ArrowBackIos sx={{ fontSize: "inherit" }} /> Back to List
          </Typography>
        </Box>
      </div>
      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} sm={12} md={12}>
            <Typography sx={{ fontWeight: "bold" }}>Entity Admin Group <span className='required'>*</span></Typography>
            <DropDown placeholder="-- Select group --" options={V_policiesListByUPN} value={adminGroup} onChange={setAdminGroup} />
            {errors.adminGroup && <Typography color="error">{errors.adminGroup}</Typography>}
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontWeight: "bold" }}>Language <span className='required'>*</span></Typography>
            <DropDown placeholder="-- Select Language --" value={language} onChange={setLanguage} options={V_languageList} />
            {errors.language && <Typography color="error">{errors.language}</Typography>}
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography sx={{ fontWeight: "bold" }}>Email Template Name <span className='required'>*</span></Typography>
            <InputControl placeholder="E.g: Email Template Publicis EN" disabled={emailData} value={emailTempName} onChange={setEmailTempName} />
            {errors.emailTempName && <Typography color="error">{errors.emailTempName}</Typography>}
          </Grid>
        </Grid>
      </Box>
      <Box sx={{
        backgroundColor: "#F6F7FA", margin: "0px 40px",
        padding: "20px"
      }}>
        <Grid container spacing={0} alignItems="left" sx={{ color: "#9D833E", display: "flex" }}>
          {['INVITATION', 'REMINDER', 'AUTO REMINDER'].map((type) => (
            <Grid item xs={12} sm={2} md={2} key={type}>
              <Box
                onClick={() => handleClick(type)}
                sx={{
                  display: "flex",
                  cursor: "pointer", // Add cursor pointer for hover effect
                  minWidth: "200px"
                }}
              >
                <Typography sx={{
                  padding: "10px",
                  borderRadius: "20px",
                  cursor: "pointer", // Add cursor pointer for hover effect
                  color: selectedType === type ? "white" : " #212129", // Conditional color styling
                  fontWeight: selectedType === type ? "600" : "normal", // Optional: Make active menu bold
                  backgroundColor: selectedType === type ? " #212129" : "",
                }}>{type} <span className='required'>*</span></Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      {selectedType === 'INVITATION' ? <Box className='boxAlignment'>
        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Subject <span className='required'>*</span></Typography>
          <InputControl placeholder="--Select Email Subject--" value={invitationEmailSubject}
            onChange={setinvitationEmailSubject} />
          {errors.invitationEmailSubject && <Typography color="error">{errors.invitationEmailSubject}</Typography>}
        </Grid>

        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Content <span className='required'>*</span></Typography>
          <QuillEditor placeholder="Please input text here" value={invitationEmailContent} onChange={(content) => setInvitationEmailContent(content.trim() === "<p><br></p>" ? "" : content)} required={true} />
          {errors.invitationEmailContent && <Typography color="error">{errors.invitationEmailContent}</Typography>}
        </Grid>
      </Box> : ""}
      {selectedType === 'REMINDER' ? <Box className='boxAlignment'>
        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Subject <span className='required'>*</span></Typography>
          <InputControl placeholder="--Select Email Subject--"  value={reminderEmailSubject} onChange={setReminderEmailSubject} />
          {errors.reminderEmailSubject && <Typography color="error">{errors.reminderEmailSubject}</Typography>}
        </Grid>

        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Content <span className='required'>*</span></Typography>
          <QuillEditor placeholder="Please input text here" value={reminderEmailContent} onChange={(content) => setReminderEmailContent(content.trim() === "<p><br></p>" ? "" : content)} required={true} />
          {errors.reminderEmailContent && <Typography color="error">{errors.reminderEmailContent}</Typography>}
        </Grid>
      </Box> : ""}
      {selectedType === 'AUTO REMINDER' ? <Box className='boxAlignment'>
        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "20px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Subject <span className='required'>*</span></Typography>
          <InputControl placeholder="--Select Email Subject--" value={autoReminderEmailSubject} onChange={setAutoReminderEmailSubject} />
          {errors.autoReminderEmailSubject && <Typography color="error">{errors.autoReminderEmailSubject}</Typography>}
        </Grid>

        <Grid item xs={12} sm={8} md={6} sx={{ marginTop: "5px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Email Content <span className='required'>*</span></Typography>
          <QuillEditor placeholder="Please input text here" value={autoReminderEmailContent} onChange={(content) => setAutoReminderEmailContent(content.trim() === "<p><br></p>" ? "" : content)} required={true} />
          {errors.autoReminderEmailContent && <Typography color="error">{errors.autoReminderEmailContent}</Typography>}
        </Grid>
      </Box> : ""
      }

      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={12} md={12} sx={{ margin: "20px", display: "flex", justifyContent: "center" }}>
          <Button label={emailData ? 'Update' : 'Save'} onClick={handleSave} isDisabled={isDisabled} />
          &nbsp;&nbsp;
          <Button label="Cancel" onClick={() => navigate(`/app-vcoi/vcoisitecontent/VcoiManageEmailTemplateHome`)} />
        </Grid>
      </Grid>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManageEmailTemplate;
